'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { List } from 'immutable';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import UIFlex from 'UIComponents/layout/UIFlex';
import EmailForm from 'MeetingsLib/components/sections/EmailForm';
import DatePickerSection from 'MeetingsLib/components/sections/DatePickerSection';
import TimeOptionsSection from 'MeetingsLib/components/sections/TimeOptionsSection';
import PropertyForm from 'MeetingsLib/components/sections/PropertyForm';
import LegalConsentForm from 'MeetingsLib/components/sections/LegalConsentForm';
import UIStickyFooter from 'UIComponents/panel/UIStickyFooter';
import classNames from 'classnames';
import FreemiumBookingUpgradeLink from 'MeetingsLib/components/freemium/FreemiumBookingUpgradeLink';
import Branding from 'MeetingsBase/models/Branding';
import UserProfile from 'MeetingsBase/models/UserProfile';
import BookingLifecycle from 'MeetingsLib/models/BookingLifecycle';
import FormState from 'MeetingsLib/models/FormState';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
var CompactBookingPage = createReactClass({
  displayName: "CompactBookingPage",
  propTypes: {
    avatar: PropTypes.string,
    companyAvatar: PropTypes.string,
    branding: PropTypes.instanceOf(Branding).isRequired,
    displayAvatarOption: PropTypes.string,
    canSubmitInitialPropertyForm: PropTypes.bool,
    embedded: PropTypes.bool.isRequired,
    headline: PropTypes.string,
    isFetchingPublicAvailability: PropTypes.bool.isRequired,
    isSalesStarter: PropTypes.bool.isRequired,
    isRescheduling: PropTypes.bool,
    profile: PropTypes.instanceOf(UserProfile),
    submittingMeeting: PropTypes.bool,
    shouldShowEmailForm: PropTypes.bool.isRequired,
    bookingLifecycle: PropTypes.instanceOf(BookingLifecycle).isRequired,
    emailFormState: PropTypes.string,
    formState: PropTypes.instanceOf(FormState),
    recaptchaEnabled: PropTypes.bool.isRequired,
    legalConsentEnabled: PropTypes.bool.isRequired,
    legalConsentResponses: PropTypes.instanceOf(List),
    resetEventDate: PropTypes.func.isRequired,
    resetEventDateTime: PropTypes.func.isRequired,
    resetFormState: PropTypes.func.isRequired,
    welcomeScreenInfo: PropTypes.instanceOf(WelcomeScreenInfo).isRequired,
    DatePickerMarker: PropTypes.func.isRequired,
    TimePickerMarker: PropTypes.func.isRequired,
    EmailFormMarker: PropTypes.func.isRequired
  },
  getLegalBackFunction: function getLegalBackFunction() {
    var _this$props = this.props,
        canSubmitInitialPropertyForm = _this$props.canSubmitInitialPropertyForm,
        resetEventDateTime = _this$props.resetEventDateTime,
        resetFormState = _this$props.resetFormState,
        isRescheduling = _this$props.isRescheduling;
    if (isRescheduling) return resetEventDateTime;
    return canSubmitInitialPropertyForm ? resetEventDateTime : resetFormState;
  },
  renderEmailFormStep: function renderEmailFormStep() {
    var _this$props2 = this.props,
        branding = _this$props2.branding,
        welcomeScreenInfo = _this$props2.welcomeScreenInfo,
        companyAvatar = _this$props2.companyAvatar,
        EmailFormMarker = _this$props2.EmailFormMarker;
    return /*#__PURE__*/_jsx(EmailForm, {
      branding: branding,
      compact: true,
      logoUrl: welcomeScreenInfo.logoUrl,
      companyAvatar: companyAvatar,
      title: welcomeScreenInfo.title,
      useCompanyLogo: welcomeScreenInfo.useCompanyLogo,
      description: welcomeScreenInfo.description,
      EmailFormMarker: EmailFormMarker
    });
  },
  renderDatePickerStep: function renderDatePickerStep() {
    var _this$props3 = this.props,
        avatar = _this$props3.avatar,
        companyAvatar = _this$props3.companyAvatar,
        branding = _this$props3.branding,
        displayAvatarOption = _this$props3.displayAvatarOption,
        embedded = _this$props3.embedded,
        headline = _this$props3.headline,
        profile = _this$props3.profile,
        DatePickerMarker = _this$props3.DatePickerMarker,
        TimePickerMarker = _this$props3.TimePickerMarker;
    return /*#__PURE__*/_jsx(DatePickerSection, {
      avatar: avatar,
      companyAvatar: companyAvatar,
      branding: branding,
      displayAvatarOption: displayAvatarOption,
      compact: true,
      embedded: embedded,
      headline: headline,
      profile: profile,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker
    }, "compact-date");
  },
  renderTimeOptionsStep: function renderTimeOptionsStep() {
    var _this$props4 = this.props,
        branding = _this$props4.branding,
        profile = _this$props4.profile,
        isFetchingPublicAvailability = _this$props4.isFetchingPublicAvailability,
        resetEventDate = _this$props4.resetEventDate,
        TimePickerMarker = _this$props4.TimePickerMarker;
    return /*#__PURE__*/_jsx(TimeOptionsSection, {
      branding: branding,
      compact: true,
      goToPreviousStep: resetEventDate,
      isFetchingPublicAvailability: isFetchingPublicAvailability,
      profile: profile,
      TimePickerMarker: TimePickerMarker
    }, "compact-time");
  },
  renderPropertyFormStep: function renderPropertyFormStep() {
    var _this$props5 = this.props,
        branding = _this$props5.branding,
        embedded = _this$props5.embedded,
        canSubmitInitialPropertyForm = _this$props5.canSubmitInitialPropertyForm,
        submittingMeeting = _this$props5.submittingMeeting,
        bookingLifecycle = _this$props5.bookingLifecycle,
        resetEventDateTime = _this$props5.resetEventDateTime;
    return /*#__PURE__*/_jsx(PropertyForm, {
      branding: branding,
      canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
      goToPreviousStep: resetEventDateTime,
      compact: true,
      embedded: embedded,
      submittingMeeting: submittingMeeting,
      dateTime: bookingLifecycle.event.dateTime
    }, "compact-property");
  },
  renderLegalConsentFormStep: function renderLegalConsentFormStep() {
    var _this$props6 = this.props,
        branding = _this$props6.branding,
        submittingMeeting = _this$props6.submittingMeeting,
        bookingLifecycle = _this$props6.bookingLifecycle;
    return /*#__PURE__*/_jsx(LegalConsentForm, {
      branding: branding,
      goToPreviousStep: this.getLegalBackFunction(),
      submittingMeeting: submittingMeeting,
      dateTime: bookingLifecycle.event.dateTime
    }, "compact-legalConsent");
  },
  renderLastStep: function renderLastStep() {
    var legalConsentEnabled = this.props.legalConsentEnabled;

    if (legalConsentEnabled) {
      return this.renderLegalConsentFormStep();
    }

    return this.renderPropertyFormStep();
  },
  renderCurrentStep: function renderCurrentStep() {
    var _this$props7 = this.props,
        shouldShowEmailForm = _this$props7.shouldShowEmailForm,
        bookingLifecycle = _this$props7.bookingLifecycle,
        emailFormState = _this$props7.emailFormState,
        formState = _this$props7.formState,
        recaptchaEnabled = _this$props7.recaptchaEnabled,
        legalConsentEnabled = _this$props7.legalConsentEnabled,
        legalConsentResponses = _this$props7.legalConsentResponses,
        submittingMeeting = _this$props7.submittingMeeting,
        isRescheduling = _this$props7.isRescheduling;

    if (shouldShowEmailForm && !emailFormState) {
      return this.renderEmailFormStep();
    }

    if (!bookingLifecycle.event.dateString) {
      return this.renderDatePickerStep();
    }

    if (!bookingLifecycle.event.dateTime) {
      return this.renderTimeOptionsStep();
    }

    if (!formState) {
      return this.renderPropertyFormStep();
    }

    if (legalConsentEnabled && !legalConsentResponses && !isRescheduling) {
      return this.renderLegalConsentFormStep();
    }

    if (submittingMeeting || recaptchaEnabled) {
      return this.renderLastStep();
    }

    return null;
  },
  render: function render() {
    var _this$props8 = this.props,
        embedded = _this$props8.embedded,
        isSalesStarter = _this$props8.isSalesStarter,
        bookingLifecycle = _this$props8.bookingLifecycle;
    var containerClasses = classNames('compact-container m-x-auto width-100 min-height-0', !embedded && 'height-100', !isSalesStarter && 'm-bottom-12');
    var hasPickedDateTime = !!bookingLifecycle.event.dateTime;
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      className: containerClasses,
      children: [/*#__PURE__*/_jsx(CSSTransitionGroup, {
        className: "flex-column width-100 min-height-0 height-100",
        transitionName: "step-animation",
        transitionEnterTimeout: 500,
        transitionLeave: false,
        children: this.renderCurrentStep()
      }), !isSalesStarter && !hasPickedDateTime && /*#__PURE__*/_jsx(UIStickyFooter, {
        children: /*#__PURE__*/_jsx(FreemiumBookingUpgradeLink, {})
      })]
    });
  }
});
export default connect(function (state) {
  return {
    isSalesStarter: state.isSalesStarter,
    isRescheduling: state.isRescheduling
  };
}, FormActions)(CompactBookingPage);